export const REQUEST_QUOTE_REQUEST = 'REQUEST_QUOTE_REQUEST';
export const REQUEST_QUOTE_SUCCESS = 'REQUEST_QUOTE_SUCCESS';
export const REQUEST_QUOTE_FAIL = 'REQUEST_QUOTE_FAIL';
export const REQUEST_QUOTE_RESET = 'REQUEST_QUOTE_RESET';